import React, { useEffect, useState } from 'react';
import YourImage from "../Assest/profile.webp"; 

const CoachIntroSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div
      style={{
        background: "linear-gradient(180deg, #000b3e 0, #020202 59%)",
        padding: "60px 20px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Outfit, sans-serif",
        color: "white",
        textAlign: "center",
      }}
    >
      {/* Section Title */}
      <div style={{ width: "100%", marginBottom: "40px" }}>
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "600",
            color: "#ffffff",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Meet Your Mentor
        </h3>
      </div>

      {/* Left Side Image */}
      <div style={{ flex: "1 1 350px", maxWidth: "400px", margin: "20px" }}>
        <img
          src={YourImage}
          alt="Coach"
          style={{
            width: "100%",
            borderRadius: "1px",
            objectFit: "cover",
          }}
        />
      </div>

      {/* Right Side Text */}
      <div
        style={{
          flex: "1 1 400px",
          maxWidth: "600px",
          textAlign: "center",
          margin: "20px",
        }}
      >
        <h2 style={{ fontSize: "28px", fontWeight: "700", color: "#FFC74B" }}>
          Billionaire Aniket
        </h2>
        <h3 style={{ fontSize: "18px", fontWeight: "600", marginTop: "10px" }}>
          Certified Life Coach & Trainer<br />
          Founder Of Billionaire Aniket Healing & Coaching LLP
        </h3>

        {/* Green underline */}
        <div
          style={{
            width: "60px",
            height: "4px",
            backgroundColor: "#2ecc71",
            margin: "20px auto",
            borderRadius: "4px",
          }}
        />

        <p style={{
          fontSize: "15px",
          lineHeight: "1.4",
          fontWeight: 500,
          textAlign: 'left',
          marginLeft:'10%'
        }}>
          नमस्कार, मी Billionaire Aniket, Certified Life Coach & Trainer, and <br/> Founder Of Billionaire Aniket Healing & Coaching LLP. तुमच्या सर्वंकष<br/> सुखासाठी, म्हणजे चांगल्या आरोग्य, प्रेम, आनंद, आदर, संपत्ती आणि यशस्वी कारकीर्द <br/>मिळवण्यासाठी, 1 लाख मराठी लोकांना मार्गदर्शन करण्याच्या ध्येयावर आहे. तुमच्या<br/> आध्यात्मिक विकासाला आणि सजगतेने जगण्याला प्राधान्य देत, आपण या प्रवासात<br/> एकत्र आहोत.🫱🏻‍🫲🏽<br />
          मला MBA आणि IT क्षेत्रात 18 वर्षांचा अनुभव आहे. मी गेल्या 13 महिन्यांत 20000 हून<br/> अधिक लोकांना मदत केली आहे. मी माझ्या स्वतःच्या आयुष्यात Law Of Attraction,<br/> होओपोनोपोनो आणि NLP या शक्तीचा वापर करून एक दशकाहून अधिक काळ<br/> घालवला आहे. मी फक्त उपदेश करत नाही; मी जे शिकवतो त्याचा सराव करतो. या<br/> प्रवासात माझ्यासोबत या. तुमची खरी क्षमता उघड करूया आणि तुमच्यासाठी जीवनात<br/> असलेली विपुलता स्वीकारूया. 🌟🚀
        </p>

        {/* CTA Button */}
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <button style={{
            background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
            color: 'white',
            fontSize: isMobile ? '18px' : '20px',
            padding: isMobile ? '10px 35px' : '22px 55px',
            border: 'none',
            borderRadius: '20px',
            fontWeight: 'bold',
            cursor: 'pointer',
            width: isMobile ? '100%' : 'auto',
          }}>
            Join The 2 Day Workshop for ₹199 &nbsp;
            <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹999</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoachIntroSection;
